/* eslint-disable max-params */

import Types from "./types";
import { BffDataAU, ListingServiceAU } from "../../../service";
import { resetReducerKeys } from "../../../constants/app-constants";

const getDeliveryInfoSuccess = ({data, pincode, payloadAddress, shippingPrice}) => ({
    type: Types.GET_DELIVERY_INFO_SUCCESS,
    data,
    pincode,
    deliveryPayloadAddress: payloadAddress,
    shippingPrice
});

const getDeliveryInfoFailure = (error, pincode) => ({
    type: Types.GET_DELIVERY_INFO_FAILURE,
    error,
    pincode
});

const setDeliveryInfoFetch = (data) => ({
    type: Types.DELIVERY_INFO_FETCHING,
    deliveryInfoFetched: data
});

const getDeliveryInfo = (appointmentId, pincode, origincity, pickUpFromParams = false, payloadAddress, originState, showDeliveryInfoLoader = true) => (dispatch, getState) => {
    if (showDeliveryInfoLoader) {
        dispatch(setDeliveryInfoFetch(false));
    }
    const {carDetails = {}, checkout: {
        currentDeliveryStep,
        order: {shippingCharge = 0} = {}
    },
    user: { secureToken }} = getState();
    const {cityCode, stateCode} = carDetails.content || {};
    return new Promise((resolve, reject) => {
        BffDataAU.getDeliveryAvailability(secureToken, appointmentId, pincode, origincity || cityCode, pickUpFromParams, originState || stateCode).then((response) => {
            dispatch(getDeliveryInfoSuccess({data: response.data, pincode, currentDeliveryStep, payloadAddress, shippingPrice: shippingCharge }));
            resolve(response.data);
        }).catch((error) => {
            dispatch(getDeliveryInfoFailure(error, pincode));
            reject(error);
        });
    });
};

const getVehiclePickUpCitiesSuccess = (data) => ({
    type: Types.GET_PICKUP_CITIES_SUCCESS,
    data
});

const getVehiclePickUpCitiesFailure = (error) => ({
    type: Types.GET_PICKUP_CITIES_FAILURE,
    error
});

const getVehiclePickUpCitiesInit = (data) => ({
    type: Types.GET_PICKUP_CITIES_INIT,
    pickUpStateLoading: data
});

const getVehiclePickUpCities = (states) => (dispatch) => {
    dispatch(getVehiclePickUpCitiesInit(false));
    return new Promise((resolve, reject) => {
        ListingServiceAU.getVehiclePickUpCities(states).then((response) => {
            dispatch(getVehiclePickUpCitiesSuccess(response.data));
            resolve(response.data);
        }).catch((error) => {
            dispatch(getVehiclePickUpCitiesFailure(error));
            reject(error);
        });
    });
};

const resetDeliveryInfo = () => dispatch => {
    dispatch({ type: resetReducerKeys.RESET_DELIVERY_INFO });
};

export {
    getDeliveryInfo,
    resetDeliveryInfo,
    setDeliveryInfoFetch,
    getVehiclePickUpCities
};

